import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import intersectClass from 'alpinejs-intersect-class'
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import WebFont from 'webfontloader';
import 'slick-carousel';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


import './styles/main.scss';


WebFont.load({
	google: {
		families: ['Roboto Slab:400,400i'],
	},
});

import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
  

/** Load Events */
jQuery(function () {

	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	  });
	jQueryBridget( 'masonry', Masonry, $ );
	Alpine.plugin(collapse);
	Alpine.plugin(focus);
	Alpine.plugin(intersect)
	Alpine.plugin(intersectClass)
	Alpine.start();
	window.Alpine = Alpine;

	jQuery(document).init(function($){

	var $grid =	$('.grid-msnry').masonry({
			itemSelector: '.grid-item',
			columnWidth: '.grid-sizer',
			percentPosition: true,
			gutter: '.gutter-sizer',
			horizontalOrder: true, // Ensures horizontal ordering
		  });
	$grid.imagesLoaded().progress( function() {
		$grid.masonry('layout');
	});

		$('p').html(function(_, text) {
			return text.replace('<!--more-->', '<button href="#" class="text-braun hover:text-blau read_more">mehr lesen</button>' );
		  });

		$('.read_more').each(function(){
			$(this).closest('p').nextAll().wrapAll('<div class="more_content hidden"></div>');
		});

		$('.read_more').each(function(){
			$(this).click(function(){
				$(this).closest('p').next('.more_content').toggleClass('hidden');
			});
		});

		$(window).scroll(function() {
			$('section').each(function(){
				var inViewport = $(this).find('h3').hasClass('viewport');
				if (inViewport == true) {
					var currentTitle = $(this).find('h3').prop('title');
				if (inViewport == true && currentTitle == 3) {
						$('li.3').addClass('active');
				} else {
					$('li.3').removeClass('active');
				}
				};
			});
		});

		$('a[href*="#"]:not([href="#"])').click(function() {
			var offset = -75; // <-- change the value here
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if (target.length) {
					$('html, body').animate({
						scrollTop: target.offset().top + offset
					}, 100);
					return false;
				}
			}
		});

		$('.js-slider').slick({
			dots: true,
			arrows: false,
			slidesToShow: 4,
			autoplay:true,
			infinite: true,
			responsive: [{
				breakpoint: 1024,
				settings: {
				  slidesToShow: 2,
				  slidesToScroll: 1,
				  centerMode: false,
				}
			  }]
		});
		});

});
